module.exports = __webpack_public_path__ + "static/media/IELTS-Listening-DragDrop1.dfdc04b9.png";